import RightPopupComponent from "components/RightPopup";

import InputPhone from "components/InputPhone";

import '../index.less';
import '../themes/default.less';

export default class ConfirmedPerson extends RightPopupComponent {
    render() {
        const { confirmedPerson, visitPersonConfiguring, changeVisitPersonConfiguring } = this.props;
        const active = confirmedPerson ? "active" : "";
        const info = (visitPersonConfiguring || {});
        const { lastName, firstName, middleName, phoneNumber, patientRelative } = info;

        return (<div className={`visitPersonConfiguring flex col gap16 ${active}`}>
            <div className="flex col gap8">
                <div className="inputs flex gap4">
                    {this.insertInput({
                        value: lastName,
                        itemStyle: "flex1",
                        label: "main.lname",
                        placeHolder: "main.lnamePlace",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: changeVisitPersonConfiguring.bind(this, info, "lastName")
                    })}
                    {this.insertInput({
                        value: firstName,
                        itemStyle: "flex1",
                        label: "main.fname",
                        placeHolder: "main.fnamePlace",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: changeVisitPersonConfiguring.bind(this, info, "firstName"),
                    })}
                    {this.insertInput({
                        value: middleName,
                        itemStyle: "flex1",
                        label: "main.sname",
                        placeHolder: "main.snamePlace",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: changeVisitPersonConfiguring.bind(this, info, "middleName"),
                    })}
                </div>
                <div className="flex flex1 gap16">
                    {this.insertInput({
                        value: patientRelative,
                        itemStyle: "flex1",
                        label: "Кем приходится",
                        placeHolder: "Брат, сестра...",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: changeVisitPersonConfiguring.bind(this, info, "patientRelative"),
                    })}
                    <InputPhone
                        value={phoneNumber}
                        itemStyle="flex1"
                        label="main.telephone"
                        onChange={changeVisitPersonConfiguring.bind(this, info, "phoneNumber")}
                    />
                </div>
            </div>
        </div>);
    }
}

